module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAhElEQVQ4T+2TsQ3CMBRE321ARYGUki5bMEfqjMEQbJOOTJApWAJFF1kKCEXGsmNK3N97/9+XReVTZZ4kwPYAtC+JpNNW+BVguweun4FSwB04r4BG0hxbNzXBBBxDKGZ+rxWj2n5Ebbkd/AJwAW7AYZ2kA56SxpIr7O8gWGz/AbUd5P7SBQIhNxHFgDNeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/facebook.png
// module id = +ces
// module chunks = 3